var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 495,
    height: 463,
    viewBox: "0 0 495 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.458 279.331C480.485 106.804 292.89 -6.20507 203.236 3.59004C113.581 13.3851 38.9983 139.947 39 250.702C39.0015 347.136 109.82 430.009 227.344 439.804C344.868 449.6 471.747 356.93 474.458 279.331Z",
    fill: "#00BFF3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 34.4717,
    width: 209.95,
    height: 148.172,
    rx: 2.5,
    fill: "white",
    stroke: "#262936"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.489,
    cy: 104.79,
    r: 19.0882,
    stroke: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.058 109.437H116.721L117.051 92.7718H112.695L113.058 109.437ZM112.86 116.202H116.919V112.308H112.86V116.202Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.00671,
    y: 192.683,
    width: 105.982,
    height: 71.3256,
    rx: 0.5,
    fill: "white",
    stroke: "#262936"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.2441,
    cy: 229.853,
    r: 19.0882,
    stroke: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8138 234.5H62.4768L62.8068 217.835H58.4508L58.8138 234.5ZM58.6158 241.265H62.6748V237.371H58.6158V241.265Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.997,
    y: 112.824,
    width: 105.982,
    height: 71.3256,
    rx: 0.5,
    fill: "white",
    stroke: "#262936"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.997,
    y: 191.177,
    width: 105.982,
    height: 71.3256,
    rx: 0.5,
    fill: "white",
    stroke: "#262936"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.997,
    y: 34.4716,
    width: 105.982,
    height: 71.3256,
    rx: 0.5,
    fill: "white",
    stroke: "#262936"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.526,
    y: 112.824,
    width: 105.982,
    height: 71.3256,
    rx: 0.5,
    fill: "white",
    stroke: "#262936"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.526,
    y: 191.177,
    width: 105.982,
    height: 71.3256,
    rx: 0.5,
    fill: "white",
    stroke: "#262936"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.526,
    y: 34.4712,
    width: 105.982,
    height: 71.3256,
    rx: 0.5,
    fill: "white",
    stroke: "#262936"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.742,
    cy: 231.36,
    r: 19.0882,
    stroke: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.311 236.007H283.974L284.304 219.342H279.948L280.311 236.007ZM280.113 242.772H284.172V238.878H280.113V242.772Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.742,
    cy: 149.993,
    r: 19.0882,
    stroke: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.311 154.64H283.974L284.304 137.975H279.948L280.311 154.64ZM280.113 161.405H284.172V157.511H280.113V161.405Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.742,
    cy: 68.6271,
    r: 19.0882,
    stroke: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.311 73.2741H283.974L284.304 56.6091H279.948L280.311 73.2741ZM280.113 80.0391H284.172V76.1451H280.113V80.0391Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.257,
    cy: 231.36,
    r: 19.0882,
    stroke: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.827 236.007H398.49L398.82 219.342H394.464L394.827 236.007ZM394.629 242.772H398.688V238.878H394.629V242.772Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.257,
    cy: 149.993,
    r: 19.0882,
    stroke: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.827 154.64H398.49L398.82 137.975H394.464L394.827 154.64ZM394.629 161.405H398.688V157.511H394.629V161.405Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.257,
    cy: 68.6271,
    r: 19.0882,
    stroke: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.827 73.2741H398.49L398.82 56.6091H394.464L394.827 73.2741ZM394.629 80.0391H398.688V76.1451H394.629V80.0391Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.963,
    cy: 372.998,
    rx: 158.212,
    ry: 25.6153,
    fill: "#393A52"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.382 235.34V212.048L228.981 195.957L241.377 232.418L203.382 235.34Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.169,
    cy: 198.964,
    r: 21.3484,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.375 232.867L190.828 234.374C200.873 246.177 221.265 269.783 222.47 269.783C223.676 269.783 237.538 246.177 244.318 234.374C243.063 229.1 237.762 222.039 237.538 222.32C235.129 225.335 212.425 226.84 201.375 227.594V232.867Z",
    fill: "#262936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.988 173.956C242.056 182.997 236.785 210.119 236.031 210.872L229.251 203.338C229.251 203.338 233.133 195.764 230.004 193.544C226.785 191.259 220.964 198.064 220.964 198.064L200.62 182.243C197.606 186.763 189.319 189.923 189.321 189.17C189.349 179.527 196.535 173.538 200.62 171.089C204.389 168.829 214.499 166.462 226.988 173.956Z",
    fill: "#262936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.074 171.877C184.805 174.804 175.76 186.944 171.239 190.711L180.28 202.765C183.796 196.487 191.732 185.287 192.334 184.684C193.088 183.931 195.225 185.563 201.375 184.684C206.649 183.931 211.42 177.401 213.429 171.876C206.649 169.616 196.855 168.11 190.074 171.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.239 190.711L170.919 190.327L170.554 190.631L170.839 191.011L171.239 190.711ZM190.074 171.877L190.317 172.314L190.074 171.877ZM213.429 171.876L213.899 172.047C213.945 171.92 213.938 171.78 213.88 171.659C213.821 171.537 213.715 171.445 213.587 171.402L213.429 171.876ZM201.375 184.684L201.304 184.189L201.375 184.684ZM192.334 184.684L192.688 185.038V185.038L192.334 184.684ZM180.28 202.765L179.88 203.065L180.341 203.68L180.716 203.01L180.28 202.765ZM171.559 191.095C173.856 189.181 177.288 185.157 180.748 181.313C182.489 179.379 184.245 177.48 185.892 175.884C187.546 174.281 189.06 173.012 190.317 172.314L189.831 171.439C188.454 172.205 186.862 173.551 185.196 175.166C183.524 176.787 181.749 178.707 180.005 180.644C176.494 184.545 173.143 188.474 170.919 190.327L171.559 191.095ZM190.317 172.314C193.597 170.492 197.637 169.93 201.729 170.116C205.816 170.302 209.914 171.232 213.271 172.351L213.587 171.402C210.164 170.261 205.974 169.308 201.774 169.117C197.579 168.926 193.332 169.495 189.831 171.439L190.317 172.314ZM212.959 171.705C211.974 174.415 210.309 177.374 208.249 179.741C206.181 182.118 203.77 183.837 201.304 184.189L201.446 185.179C204.254 184.778 206.865 182.855 209.004 180.398C211.15 177.931 212.875 174.863 213.899 172.047L212.959 171.705ZM201.304 184.189C198.286 184.62 196.263 184.435 194.903 184.236C194.246 184.14 193.662 184.026 193.241 183.991C192.819 183.956 192.338 183.973 191.981 184.33L192.688 185.038C192.707 185.018 192.776 184.956 193.159 184.988C193.543 185.02 194.018 185.118 194.759 185.226C196.193 185.435 198.314 185.626 201.446 185.179L201.304 184.189ZM191.981 184.33C191.874 184.437 191.659 184.714 191.387 185.077C191.103 185.457 190.728 185.971 190.285 186.589C189.399 187.826 188.238 189.482 186.987 191.314C184.487 194.976 181.613 199.361 179.844 202.521L180.716 203.01C182.463 199.891 185.315 195.537 187.813 191.878C189.06 190.051 190.216 188.401 191.097 187.172C191.538 186.557 191.909 186.049 192.188 185.676C192.327 185.49 192.442 185.339 192.531 185.227C192.575 185.171 192.611 185.126 192.64 185.093C192.654 185.076 192.665 185.063 192.674 185.053C192.678 185.048 192.682 185.044 192.684 185.041C192.687 185.039 192.688 185.037 192.688 185.038L191.981 184.33ZM180.68 202.465L171.639 190.411L170.839 191.011L179.88 203.065L180.68 202.465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.762 293.892L135.187 392.586C156.885 399.818 247.694 397.609 290.386 395.6L287.833 309.713C294.765 294.314 297.31 277.386 295.659 264.509C292.646 241.003 262.761 228.598 248.196 225.333L210.526 257.729C207.01 248.688 197.718 230.155 188.678 228.346C179.637 226.538 153.771 233.118 141.967 236.634L183.404 201.978L172.857 187.663C148.748 194.193 99.9285 213.731 97.5177 239.647C95.1068 265.564 132.676 286.609 151.762 293.892Z",
    fill: "#01BFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.213 263.003L178.02 266.77V299.919L165.213 293.138V263.003Z",
    fill: "#262936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.479 291.467C159.702 295.912 168.529 303.521 173.3 306.535L181.588 297.494C181.839 291.467 185.355 280.167 184.602 279.413C183.354 278.164 181.588 277.152 180.081 279.413C178.574 281.673 179.328 284.686 174.807 286.947C171.191 288.755 161.246 278.659 157.479 278.659C152.477 278.659 155.219 286.947 157.479 291.467Z",
    fill: "white",
    stroke: "#262936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.733 311.973L169.36 311.64L169.127 311.9L169.292 312.208L169.733 311.973ZM182.54 297.659L182.826 297.248L182.463 296.995L182.168 297.325L182.54 297.659ZM236.031 311.973L235.586 311.745L235.214 312.473H236.031V311.973ZM235.969 351.407C219.26 353.495 204.823 347.346 193.541 338.772C182.255 330.195 174.163 319.217 170.174 311.738L169.292 312.208C173.339 319.797 181.52 330.893 192.936 339.569C204.357 348.248 219.05 354.529 236.093 352.399L235.969 351.407ZM170.105 312.306L182.913 297.992L182.168 297.325L169.36 311.64L170.105 312.306ZM182.255 298.069C186.424 300.975 193.611 305.249 201.651 308.648C209.679 312.041 218.622 314.591 226.277 313.978L226.197 312.981C218.785 313.574 210.023 311.101 202.041 307.727C194.071 304.358 186.944 300.118 182.826 297.248L182.255 298.069ZM226.277 313.978C233.791 313.377 237.042 312.998 238.031 312.761C238.156 312.731 238.278 312.696 238.376 312.65C238.42 312.63 238.504 312.588 238.579 312.511C238.662 312.424 238.796 312.216 238.697 311.955C238.625 311.764 238.469 311.681 238.429 311.66C238.366 311.628 238.304 311.609 238.259 311.597C238.167 311.572 238.058 311.555 237.95 311.542C237.517 311.491 236.783 311.473 236.031 311.473V312.473C236.786 312.473 237.465 312.492 237.833 312.535C237.925 312.546 237.978 312.557 238.001 312.563C238.014 312.566 237.998 312.563 237.969 312.548C237.961 312.545 237.827 312.48 237.762 312.309C237.67 312.067 237.798 311.879 237.861 311.814C237.891 311.783 237.919 311.765 237.931 311.757C237.945 311.748 237.955 311.743 237.956 311.743C237.957 311.742 237.947 311.747 237.917 311.756C237.889 311.765 237.85 311.776 237.798 311.788C236.904 312.003 233.751 312.377 226.197 312.981L226.277 313.978ZM236.476 312.201L253.051 279.805L252.161 279.349L235.586 311.745L236.476 312.201ZM283.682 313.275C274.845 332.906 259.448 348.472 235.969 351.407L236.093 352.399C260.016 349.409 275.66 333.533 284.594 313.685L283.682 313.275Z",
    fill: "#262936"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.33 450.597C302.33 450.597 429.95 414.44 464.309 348.136C489.686 299.165 486.911 270.536 486.911 270.536",
    stroke: "#393A52"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 494.5,
    height: 462.078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 56.7511,
    y: 345.382,
    width: 328.425,
    height: 63.2306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 295.194,
    y: 267.489,
    width: 199.306,
    height: 194.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/server-error.7de33b44.svg";
export { ForwardRef as ReactComponent };